import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { brand } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#f5f7f6] border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/"><Logo height={56} /></Link>
            <p className="text-[#4b5563] text-[13px] mt-5 max-w-md leading-relaxed">{brand.tagline}</p>
            <p className="text-[#4b5563] text-[13px] mt-2 max-w-md leading-relaxed">Masjid Suite is a product of <span className="text-[#1d1d1f] font-medium">Harmonia Enterprises LLC</span>.</p>
            <div className="mt-6 space-y-2 text-[13px]">
              <a href={`tel:${brand.phoneTel}`} className="flex items-center gap-2 text-[#1d1d1f] hover:text-[#0e2408]"><Phone size={14} /> {brand.phone}</a>
              <a href={`mailto:${brand.email}`} className="flex items-center gap-2 text-[#1d1d1f] hover:text-[#0e2408] break-all"><Mail size={14} /> {brand.email}</a>
              <div className="flex items-center gap-2 text-[#4b5563]"><MapPin size={14} /> {brand.address}</div>
            </div>
          </div>
          <div>
            <div className="text-[#1d1d1f] font-semibold mb-4 text-[13px]">Features</div>
            <ul className="space-y-2.5 text-[12px] text-[#4b5563]">
              <li><Link to="/software" className="hover:text-[#0e2408]">All Free Features</Link></li>
              <li><Link to="/member-app" className="hover:text-[#0e2408]">Member App</Link></li>
              <li><Link to="/admin-app" className="hover:text-[#0e2408]">Admin App</Link></li>
              <li><Link to="/tap-and-pay" className="hover:text-[#0e2408]">Tap & Pay App</Link></li>
              <li><Link to="/kiosk" className="hover:text-[#0e2408]">Kiosk</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-[#1d1d1f] font-semibold mb-4 text-[13px]">Company</div>
            <ul className="space-y-2.5 text-[12px] text-[#4b5563]">
              <li><Link to="/why-us" className="hover:text-[#0e2408]">Why Us</Link></li>
              <li><Link to="/why-us#how-we-stay-free" className="hover:text-[#0e2408]">How We Stay Free</Link></li>
              <li><Link to="/faq" className="hover:text-[#0e2408]">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#0e2408]">Contact</Link></li>
            </ul>
            <div className="text-[#1d1d1f] font-semibold mb-4 mt-6 text-[13px]">Legal</div>
            <ul className="space-y-2.5 text-[12px] text-[#4b5563]">
              <li><a href="#" className="hover:text-[#0e2408]">Terms of Use</a></li>
              <li><Link to="/privacy-policy" className="hover:text-[#0e2408]">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-black/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-2 text-[12px] text-[#6b7280]">
          <div>© {new Date().getFullYear()} Masjid Suite. All rights reserved.</div>
          <div className="text-[#0e2408]">Free software. Honest hardware. Built for masjid.</div>
        </div>
      </div>
    </footer>
  );
}
